import * as Modal from '../../../components/modal'
import * as ModalActions from '../../../components/modal/actions'
import * as ModalTypes from '../../../components/modal/types'
import * as Request from '../../../request'
import * as Constants from './constants'

const modalReducerEvent: Modal.ReducerEvent<{}> = {
  initializeState: () => ({}),
  requestEvent: Constants.SEND_EMAIL_FUTURE_DATE,
}
export const modalReducer = Modal.reducer(modalReducerEvent)

type Action = ModalActions.UpdateFieldAction & Request.SuccessAction
export const keepModalOpenReducer = <T extends ModalTypes.ModalData>
  (state: ModalTypes.State<T>, action: Action): ModalTypes.State<T> => {
    switch (action.type) {
      case Request.successConstant(Constants.SEND_EMAIL_FUTURE_DATE):
        if (action.payload.response.statusMessage === Constants.CONTENT_FAILURE) {
          return {
            ...state,
            isOpen: true,
            isSubmitting: false,
            submitSuccess: false,
          }
        }
      default:
        return state
    }
  }



// WEBPACK FOOTER //
// ./src/pages/content-calendar/send-email-modal/reducer.ts